//A modal that automatically creates a modal
import React, {Component} from "react";
import CloseIcon from "../../resources/icons/delete.svg";
import PropTypes from "prop-types";
import {AppearTransition} from "../animations";

export class Modal extends Component {
	
	state = {
		show: true
	};
	
	constructor(props) {
		super(props);
		
		this.onHide = () => {
			this.setState({show: false});
			this.props.onHide && this.props.onHide();
		}
	}
	
	render() {
		let {children, className, onHide, icon, background} = this.props;
		const show = this.props.hasOwnProperty("show") ? this.props.show : this.state.show;
		return (
			<AppearTransition animation="growCenter" show={show} appear={true} onExited={onHide}>
				<div className="modalBackground" onClick={this.onHide}>
					<div className={["modal", className].join(" ")}
					     onClick={e => e.stopPropagation()}
					     style={{backgroundImage: `url(${background})`}}>
						<div className="modalHeader">
							<div className="modalHeaderIcon">
								<img src={icon}/>
							</div>
							<img className="closeModal" src={CloseIcon} onClick={this.onHide}/>
						</div>
						<div className="modalContent">
							{children}
						</div>
					</div>
				</div>
			</AppearTransition>
		);
	}
}

Modal.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	onHide: PropTypes.func
};

export const ProductModal = ({children, className, onHide}) => (
	<div className="productModalBackground" onClick={onHide}>
		<div className={["productModal maxWidth", className].join(" ")}
		     onClick={e => e.stopPropagation()}
		>
			<img className="closeModal" src={CloseIcon} onClick={onHide}/>
			<div className="modalContent">
				{children}
			</div>
		</div>
	</div>

);


// WEBPACK FOOTER //
// ./src/components/common/modal.js